var chunkMapping = {
	"apps_console-host_src_main_tsx": [
		60866,
		64865,
		62318,
		4924,
		76710,
		73064,
		85196,
		17369,
		61097,
		86444,
		25482,
		60487,
		97267,
		20226,
		38791,
		29281,
		25477,
		79994,
		99946,
		85777,
		16283,
		23036
	]
};
var idToExternalAndNameMapping = {
	"4924": [
		"default",
		"./styles",
		67178
	],
	"16283": [
		"default",
		"./Constants",
		2708
	],
	"17369": [
		"default",
		"./styles",
		4904
	],
	"20226": [
		"default",
		"./Constants",
		30849
	],
	"23036": [
		"default",
		"./Constants",
		78434
	],
	"25477": [
		"default",
		"./Constants",
		1473
	],
	"25482": [
		"default",
		"./styles",
		2708
	],
	"29281": [
		"default",
		"./Constants",
		67178
	],
	"38791": [
		"default",
		"./Constants",
		99013
	],
	"60487": [
		"default",
		"./styles",
		78434
	],
	"60866": [
		"default",
		"./styles",
		27764
	],
	"61097": [
		"default",
		"./styles",
		48758
	],
	"62318": [
		"default",
		"./styles",
		99013
	],
	"64865": [
		"default",
		"./styles",
		30849
	],
	"73064": [
		"default",
		"./styles",
		1473
	],
	"76710": [
		"default",
		"./Components",
		1473
	],
	"79994": [
		"default",
		"./Constants",
		4904
	],
	"85196": [
		"default",
		"./styles",
		59813
	],
	"85777": [
		"default",
		"./Constants",
		12011
	],
	"86444": [
		"default",
		"./styles",
		12011
	],
	"97267": [
		"default",
		"./Constants",
		27764
	],
	"99946": [
		"default",
		"./Constants",
		48758
	]
};
var idToRemoteMap = {
	"4924": [
		{
			"externalType": "script",
			"name": "dxpConfiguration",
			"externalModuleId": 67178
		}
	],
	"16283": [
		{
			"externalType": "script",
			"name": "dxpMonitoring",
			"externalModuleId": 2708
		}
	],
	"17369": [
		{
			"externalType": "script",
			"name": "dxpCustomerDataPlatform",
			"externalModuleId": 4904
		}
	],
	"20226": [
		{
			"externalType": "script",
			"name": "dxpArtificialIntelligence",
			"externalModuleId": 30849
		}
	],
	"23036": [
		{
			"externalType": "script",
			"name": "dxpOptimization",
			"externalModuleId": 78434
		}
	],
	"25477": [
		{
			"externalType": "script",
			"name": "dxpConsoleCore",
			"externalModuleId": 1473
		}
	],
	"25482": [
		{
			"externalType": "script",
			"name": "dxpMonitoring",
			"externalModuleId": 2708
		}
	],
	"29281": [
		{
			"externalType": "script",
			"name": "dxpConfiguration",
			"externalModuleId": 67178
		}
	],
	"38791": [
		{
			"externalType": "script",
			"name": "dxpComponentService",
			"externalModuleId": 99013
		}
	],
	"60487": [
		{
			"externalType": "script",
			"name": "dxpOptimization",
			"externalModuleId": 78434
		}
	],
	"60866": [
		{
			"externalType": "script",
			"name": "dxpAdministration",
			"externalModuleId": 27764
		}
	],
	"61097": [
		{
			"externalType": "script",
			"name": "dxpDigitalAssetManagement",
			"externalModuleId": 48758
		}
	],
	"62318": [
		{
			"externalType": "script",
			"name": "dxpComponentService",
			"externalModuleId": 99013
		}
	],
	"64865": [
		{
			"externalType": "script",
			"name": "dxpArtificialIntelligence",
			"externalModuleId": 30849
		}
	],
	"73064": [
		{
			"externalType": "script",
			"name": "dxpConsoleCore",
			"externalModuleId": 1473
		}
	],
	"76710": [
		{
			"externalType": "script",
			"name": "dxpConsoleCore",
			"externalModuleId": 1473
		}
	],
	"79994": [
		{
			"externalType": "script",
			"name": "dxpCustomerDataPlatform",
			"externalModuleId": 4904
		}
	],
	"85196": [
		{
			"externalType": "script",
			"name": "dxpContentManagement",
			"externalModuleId": 59813
		}
	],
	"85777": [
		{
			"externalType": "script",
			"name": "dxpInstanceManagement",
			"externalModuleId": 12011
		}
	],
	"86444": [
		{
			"externalType": "script",
			"name": "dxpInstanceManagement",
			"externalModuleId": 12011
		}
	],
	"97267": [
		{
			"externalType": "script",
			"name": "dxpAdministration",
			"externalModuleId": 27764
		}
	],
	"99946": [
		{
			"externalType": "script",
			"name": "dxpDigitalAssetManagement",
			"externalModuleId": 48758
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}